/*
@file-overview 

- This file contains the required information for succesful requests for needed services
    within the different enviorments

*/
export const EnviormentConfig = {
    dev1 :{
      currentEnv : "dev1",
      baseURL : "https://www-dev1.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/qapub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'cb8c6ba089134b799a5892ed7bb5dae9'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/acceptancepub/xapi/search/substitute',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '061d4366162045c6879eca9eab9b7e89'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '282a6d0c0ff142e485e58154cd248c2d'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: '051db3bccc0f490aad2be512ca4f4fe2'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/qapub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/qapub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        apimBasePath:'/abs/qapub',
        cartV2API : '/abs/qapub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "acceptance.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/acceptancepub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "061d4366162045c6879eca9eab9b7e89",
        "apim.api.catalog.path" : "/abs/acceptancepub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/devpub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "133050c8da964dafb63bcb6c6aba00a0",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "652b1bdf-df33-43e2-81e3-278fecf91c5c",
        'X-IBM-Client-Secret': "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
        'clipPath' : '/abs/qa1pub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/qa1pub/web/j4u/api/offers/unclip'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/acceptancepub/xapi/offers',
        'upcsByOfferIds': '/abs/acceptancepub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/devpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"49c7b49a2bf94a5ca7e318c84ca9cbb2",
        snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
        arAuthorizeBasePath: "/abs/acceptancepub",
        arScriptBasePath: "/abs/acceptancepub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "e5b1bf4a9c124561ba364ac53c2cbc66"
      },
      wiremockAPIDetails: {
        allowWiremockService: true,
        subscriptionKey: "35570fd5f27f4d69948bafbb4dd4f878",
        playbackBaseUrl: "/abs/acceptancepub/mock-playback/mockinator/playback",
        recorderBaseUrl: "/abs/acceptancepub/mock-recorder/mockinator"
      },
      snsConfig: {
        url: '/abs/acceptancepub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '91630a74fd484185bc2fc20fff6cd057'
        }
      },
      domsApiDetails : {
        url : '/abs/qapub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e3805df8a69a41c3811c068c8a9263ca'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABSStage"
    },
    dev2 : {
      currentEnv : "qa1",
      baseURL : "https://www-dev2.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/qapub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'cb8c6ba089134b799a5892ed7bb5dae9'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/acceptancepub/xapi/search/substitute',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '061d4366162045c6879eca9eab9b7e89'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '282a6d0c0ff142e485e58154cd248c2d'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: '051db3bccc0f490aad2be512ca4f4fe2'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/qapub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/qapub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        apimBasePath:'/abs/qapub',
        cartV2API : '/abs/qapub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "acceptance.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/acceptancepub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "061d4366162045c6879eca9eab9b7e89",
        "apim.api.catalog.path" : "/abs/acceptancepub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "acceptance.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/acceptancepub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "061d4366162045c6879eca9eab9b7e89",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "133050c8da964dafb63bcb6c6aba00a0",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "652b1bdf-df33-43e2-81e3-278fecf91c5c",
        'X-IBM-Client-Secret': "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
        'clipPath' : '/abs/qa1pub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/qa1pub/web/j4u/api/offers/unclip'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/acceptancepub/xapi/offers',
        'upcsByOfferIds': '/abs/acceptancepub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/devpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"45000d8081a744fb858f26f463d4f5ae",
        snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
        arAuthorizeBasePath: "/abs/acceptancepub",
        arScriptBasePath: "/abs/acceptancepub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "e5b1bf4a9c124561ba364ac53c2cbc66"
      },
      wiremockAPIDetails: {
        allowWiremockService: true,
        subscriptionKey: "35570fd5f27f4d69948bafbb4dd4f878",
        playbackBaseUrl: "/abs/acceptancepub/mock-playback/mockinator/playback",
        recorderBaseUrl: "/abs/acceptancepub/mock-recorder/mockinator"
      },
      snsConfig: {
        url: '/abs/acceptancepub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '91630a74fd484185bc2fc20fff6cd057'
        }
      },
      domsApiDetails : {
        url : '/abs/qapub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e3805df8a69a41c3811c068c8a9263ca'
        }
      }
    },
    dev3 : {
      currentEnv : "qa1",
      baseURL : "https://www-dev3.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/qapub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'cb8c6ba089134b799a5892ed7bb5dae9'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/acceptancepub/xapi/search/substitute',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '061d4366162045c6879eca9eab9b7e89'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '282a6d0c0ff142e485e58154cd248c2d'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: '051db3bccc0f490aad2be512ca4f4fe2'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/qapub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/qapub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        apimBasePath:'/abs/qapub',
        cartV2API : '/abs/qapub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/devpub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "apim.api.catalog.path" : "/abs/devpub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/devpub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "b5d01bd0-3c93-46cb-a63e-7dced08b617d",
        'X-IBM-Client-Secret': "xC6lD4nL7hY4cF6pJ6dO8fV5vM1aA6lL6hT4lX1rV0lV1vQ0hU",
        'clipPath' : '/abs/dvpub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/dvpub/web/j4u/api/offers/unclip'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/devpub/xapi/offers',
        'upcsByOfferIds': '/abs/devpub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/devpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"45000d8081a744fb858f26f463d4f5ae",
        snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
        arAuthorizeBasePath: "/abs/acceptancepub",
        arScriptBasePath: "/abs/acceptancepub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "6125bedf8ff9460aa41739349be602db"
      },
      wiremockAPIDetails: {
        allowWiremockService: false,
        subscriptionKey: "",
        playbackBaseUrl: "",
        recorderBaseUrl: ""
      },
      snsConfig: {
        url: '/abs/devpub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '91630a74fd484185bc2fc20fff6cd057'
        }
      },
      domsApiDetails : {
        url : '/abs/qapub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e3805df8a69a41c3811c068c8a9263ca'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABSStage"
    },
    qa1 : {
      currentEnv : "qa1",
      baseURL : "https://www-qa1.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/qapub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '8ca6295a55f54368844b5982edc1cc01'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/qapub/xapi/search/substitute',
        searchParam : 'https://www-qa1.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'a6bbc777a82f45a9b1413af0ce35604f'
        }
      },      
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/qapub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'ae53203f912448a7a13c70272d5c75fb'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: '6952f7ab5d204b73a8c514c71fcc68c5'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/qapub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/qapub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        apimBasePath:'/abs/qapub',
        cartV2API : '/abs/qapub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "qa.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/qapub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "b0f931272efc4766a535e6030b79574d",
        "apim.api.catalog.path" : "/abs/qapub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "qa.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/qapub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "a6bbc777a82f45a9b1413af0ce35604f",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "b0f931272efc4766a535e6030b79574d",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "9b1d97cf-4ddc-4e81-95e5-035c204c4ef6",
        'X-IBM-Client-Secret': "G1oW7jM5jF5nV7lR8rC6dU4wG1qS8uC5iD7rB5eJ0tD4eO0cJ6",
        "X-SWY_BANNER": "safeway",
        "x-swy-correlation-id": "01e7b8fd-f501-4519-886c-daf340fa6967",
        "X-SWY_API_KEY": "emjou",
        "X-SWY-APPLICATION-TYPE": "web",
        "X-SWY_VERSION_Offers": "1.1",
        'clipPath' : '/abs/qapub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/qapub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/qapub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/qapub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/qapub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/qapub/xapi/offers',
        'upcsByOfferIds': '/abs/qapub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/qapub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"6173c51c68254b0dada9ce698e96d2f3",
        snsEndpointAllSubscriptionsKey: "267402756dc5413ab6ec8bc403100042",
        arAuthorizeBasePath: "/abs/qapub",
        arScriptBasePath: "/abs/qapub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "b63410670d33422186409d4ad55c9030"
      },
      wiremockAPIDetails: {
        allowWiremockService: true,
        subscriptionKey: "8ca6295a55f54368844b5982edc1cc01",
        playbackBaseUrl: "/abs/qapub/mock-playback/mockinator/playback",
        recorderBaseUrl: "/abs/qapub/mock-recorder/mockinator"
      },
      snsConfig: {
        url: '/abs/qapub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '2df5532da15c4218b46d35ecd6c6a699'
        }
      },
      domsApiDetails : {
        url : '/abs/qapub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e3805df8a69a41c3811c068c8a9263ca'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABSStage"
    },
    qa2 : {
      currentEnv : "qa2",
      baseURL : "https://www-qa2.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/acceptancepub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '35570fd5f27f4d69948bafbb4dd4f878'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/acceptancepub/xapi/search/substitute',
        searchParam : 'https://www-qa2.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '061d4366162045c6879eca9eab9b7e89'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '282a6d0c0ff142e485e58154cd248c2d'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: 'cbca35c27eab4e57924becd81cee41c9'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/acceptancepub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/acceptancepub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '26dfa6ab7afe4a88805ce9f5351b78b4'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'ab4d24c982614a3ba20e1ae0593ed3b5'
        },
        apimBasePath:'/abs/acceptancepub',
        cartV2API : '/abs/acceptancepub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "acceptance.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/acceptancepub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "061d4366162045c6879eca9eab9b7e89",
        "apim.api.catalog.path" : "/abs/acceptancepub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "acceptance.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/acceptancepub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "061d4366162045c6879eca9eab9b7e89",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "133050c8da964dafb63bcb6c6aba00a0",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "652b1bdf-df33-43e2-81e3-278fecf91c5c",
        'X-IBM-Client-Secret': "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
        'clipPath' : '/abs/qa1pub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/qa1pub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/qa1pub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/acceptancepub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/acceptancepub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/acceptancepub/xapi/offers',
        'upcsByOfferIds': '/abs/acceptancepub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/acceptancepub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/acceptancepub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"49c7b49a2bf94a5ca7e318c84ca9cbb2",
        snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
        arAuthorizeBasePath: "/abs/acceptancepub",
        arScriptBasePath: "/abs/acceptancepub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "e5b1bf4a9c124561ba364ac53c2cbc66"
      },
      wiremockAPIDetails: {
        allowWiremockService: true,
        subscriptionKey: "35570fd5f27f4d69948bafbb4dd4f878",
        playbackBaseUrl: "/abs/acceptancepub/mock-playback/mockinator/playback",
        recorderBaseUrl: "/abs/acceptancepub/mock-recorder/mockinator"
      },
      snsConfig: {
        url: '/abs/acceptancepub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '64e226bfbc1148d3b3f076a33d654595',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '91630a74fd484185bc2fc20fff6cd057'
        }
      },
      domsApiDetails : {
        url : '/abs/acceptancepub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'f41f3f42af6c45dba291b8598b1af99e'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABSStage"
    },
    qa3 : {
      currentEnv : "qa3",
      baseURL : "https://www-qa3.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/perfpub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '6eb4decfcd01473aa5ee0a690cc39006'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/perfpub/xapi/search/substitute',
        searchParam : 'https://www-qa3.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '49384d1586e9426ab1ab525c95cf18ff'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/perfpub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'a51715bbe5a64a9bb5c008d80d38e362'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: '656233f099754e94b1e1e42f71c4677f'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/perfpub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/perfpub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'b029945667514b5a887e4764fa1f6df9'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'abb0423b458e4cf6a1f1dad5666a5127'
        },
        apimBasePath:'/abs/perfpub',
        cartV2API : '/abs/perfpub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "perf.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/perfpub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "49384d1586e9426ab1ab525c95cf18ff",
        "apim.api.catalog.path" : "/abs/perfpub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "perf.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/perfpub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "49384d1586e9426ab1ab525c95cf18ff",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "19e5b39b4afc425bba33841a60a9dcd5",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "f537e42e-b56e-4c08-b4cf-159735dc889b",
        'X-IBM-Client-Secret': "eL0uY3yM2lF6kJ7jN2fO5jA0qP3lK2vX3pX5hM1cX3nS7uJ3mA",
        'clipPath' : '/abs/qa1pub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/qa1pub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/qa1pub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/perfpub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/perfpub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/perfpub/xapi/offers',
        'upcsByOfferIds': '/abs/perfpub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/perfpub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/perfpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"c8a4300d1b5048c5946b6b11e5bd9919",
        snsEndpointAllSubscriptionsKey: "46d30fd9331a4faa9dd20dce1d4db0f3",
        arAuthorizeBasePath: "/abs/perfpub",
        arScriptBasePath: "/abs/perfpub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "2af9cc1fbd3348f1bf4c47ee480542e5"
      },
      wiremockAPIDetails: {
        allowWiremockService: false,
        subscriptionKey: "",
        playbackBaseUrl: "",
        recorderBaseUrl: ""
      },
      snsConfig: {
        url: '/abs/perfpub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '46d30fd9331a4faa9dd20dce1d4db0f3',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '65658511817643ecb6de198796934cea'
        }
      },
      domsApiDetails : {
        url : '/abs/perfpub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '9d74e4b228194e65b8c103cf7a7bb72b'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABS"
    },
    stage : {
      currentEnv : "stage",
      baseURL : "https://www-stage.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/stgpub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'f8bee8d7e7d14a11ac8197d3088cbe3b'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/stgpub/xapi/search/substitute',
        searchParam : 'https://www-stage.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'f42494b71bf94bd1b87f937a60ee990e'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/stagepub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'b47044a7120d4a25aba1738170f979aa'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: 'e4c13d90a2c04e858e9327d9908caaa0'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/stgpub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/stgpub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'b67277d0d0d04e0da852c5e79b19b025'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '221f4ec2121a4e79a2676ffb0dae44e0'
        },
        apimBasePath:'/abs/stgpub',
        cartV2API : '/abs/stgpub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "stage.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/stagepub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "f42494b71bf94bd1b87f937a60ee990e",
        "apim.api.catalog.path" : "/abs/stgpub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "stage.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/stagepub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "f42494b71bf94bd1b87f937a60ee990e",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "f8bee8d7e7d14a11ac8197d3088cbe3b",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "b09e2ed0-494d-44da-bb90-70de110efb31",
        'X-IBM-Client-Secret': "P1wX4nX1dG1iG2kM0sY0sB0rJ4oT0jT2wC1mG1vF7uY7kL3yE7",
        'clipPath' : '/abs/stgpub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/stgpub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/stgpub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/stgpub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/stgpub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/stgpub/xapi/offers',
        'upcsByOfferIds': '/abs/stgpub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/stgpub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpc': '/abs/pub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"0c289898aecf49079e191d369ac648ae",
        snsEndpointAllSubscriptionsKey: "b47044a7120d4a25aba1738170f979aa",
        arAuthorizeBasePath: "/abs/stagepub",
        arScriptBasePath: "/abs/stgpub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "38c2e3420b8b450d9ffd5564ff22c4f0"
      },
      wiremockAPIDetails: {
        allowWiremockService: false,
        subscriptionKey: "",
        playbackBaseUrl: "",
        recorderBaseUrl: ""
      },
      snsConfig: {
        url: '/abs/stagepub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: 'b47044a7120d4a25aba1738170f979aa',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '7d8e333208044063949a4ae9a8837b0d'
        }
      },
      domsApiDetails : {
        url : '/abs/stagepub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '4dcf2a6910e84631b442b91197a282a8'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABS"
    },
    betaprod : {
      currentEnv : "prod",
      baseURL : "https://www-beta.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/pub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '7bad9afbb87043b28519c4443106db06'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/pub/xapi/search/substitute',
        searchParam : 'https://www-beta.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e914eec9448c4d5eb672debf5011cf8f'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/pub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '5e790236c84e46338f4290aa1050cdd4'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: 'f775c6e1cecf4ec5849ea7fb1add9114'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/pub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/pub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'ce4dc2965ed34e6288cdad05f2ef2ed2'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'c645e9387c654aa8ae253045f648bfac'
        },
        apimBasePath:'/abs/pub',
        cartV2API : '/abs/pub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "prod.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/pub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "e914eec9448c4d5eb672debf5011cf8f",
        "apim.api.catalog.path" : "/abs/pub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "prod.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/pub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "e914eec9448c4d5eb672debf5011cf8f",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "7bad9afbb87043b28519c4443106db06",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "306b9569-2a31-4fb9-93aa-08332ba3c55d",
        'X-IBM-Client-Secret': "N4tK3pW7pP6nB4kL6vN4kW0rS5lE4qH2fY0aB2rK1eP5gK4yV5",
        'clipPath' : '/abs/pub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/pub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/pub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/pub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/pub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/pub/xapi/offers',
        'upcsByOfferIds': '/abs/pub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/pub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/pub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABS/",
        arSubscriptionKey:"fee1766a73bf47e49fa1e6a02b53308c",
        snsEndpointAllSubscriptionsKey: "379d5b830a494af18fb37cb379afb675",
        arAuthorizeBasePath: "/abs/pub",
        arScriptBasePath: "/abs/pub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "1d8f9e6f8b0d4ce29468d6d82f5847b8"
      },
      wiremockAPIDetails: {
        allowWiremockService: false,
        subscriptionKey: "",
        playbackBaseUrl: "",
        recorderBaseUrl: ""
      },
      snsConfig: {
        url: '/abs/pub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '379d5b830a494af18fb37cb379afb675',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '6c21edb7bcda4f0e918348db16147431'
        }
      },
      domsApiDetails : {
        url : '/abs/pub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '281a87fa52ad4a9d8c4190482d0ea660'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABS"
    },
    prod : {
      currentEnv : "prod",
      baseURL : "https://www.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/pub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '7bad9afbb87043b28519c4443106db06'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/pub/xapi/search/substitute',
        searchParam : 'https://www.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e914eec9448c4d5eb672debf5011cf8f'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/pub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '5e790236c84e46338f4290aa1050cdd4'
        }
      },
      subscriptionAPIDetails: {
        subscriptionApi: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
        subscriptionKey: {
          key: 'ocp-apim-subscription-key',
          value: 'f775c6e1cecf4ec5849ea7fb1add9114'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/pub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/pub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'ce4dc2965ed34e6288cdad05f2ef2ed2'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : 'c645e9387c654aa8ae253045f648bfac'
        },
        apimBasePath:'/abs/pub',
        cartV2API : '/abs/pub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "prod.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/pub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "e914eec9448c4d5eb672debf5011cf8f",
        "apim.api.catalog.path" : "/abs/pub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "prod.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/pub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "e914eec9448c4d5eb672debf5011cf8f",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "7bad9afbb87043b28519c4443106db06",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "306b9569-2a31-4fb9-93aa-08332ba3c55d",
        'X-IBM-Client-Secret': "N4tK3pW7pP6nB4kL6vN4kW0rS5lE4qH2fY0aB2rK1eP5gK4yV5",
        'clipPath' : '/abs/pub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/pub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/pub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/pub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/pub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/pub/xapi/offers',
        'upcsByOfferIds': '/abs/pub/dce/offergallery/J4UProgram1/offer/upcs',
        'offerDetailsPzn': '/abs/pub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/pub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        'coupon.image.base.url' : 'https://images.albertsons-media.com/is/image/ABS/',
        arSubscriptionKey:"fee1766a73bf47e49fa1e6a02b53308c",
        snsEndpointAllSubscriptionsKey: "379d5b830a494af18fb37cb379afb675",
        arAuthorizeBasePath: "/abs/pub",
        arScriptBasePath: "/abs/pub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "9e38e3f1d32a4279a49a264e0831ea46"
      },
      wiremockAPIDetails: {
        allowWiremockService: false,
        subscriptionKey: "",
        playbackBaseUrl: "",
        recorderBaseUrl: ""
      },
      snsConfig: {
        url: '/abs/pub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '379d5b830a494af18fb37cb379afb675',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '6c21edb7bcda4f0e918348db16147431'
        }
      },
      domsApiDetails : {
        url : '/abs/pub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '281a87fa52ad4a9d8c4190482d0ea660'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABS"
    },
    local : {
      currentEnv : "qa1",
      baseURL : "https://www-qa1.{banner}.com",
      substitutionAPIDetails : {
        substitutionAPI : '/abs/qapub/xapi/pdreco/substitution',
        xtokenHeader : {
          key : 'X-access-token',
          value : ''
        },
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '8ca6295a55f54368844b5982edc1cc01'
        }
      },
      searchAPIDetails : {
        searchAPI : '/abs/qapub/xapi/search/substitute',
        searchParam : 'https://www-qa1.{banner}.com',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : '061d4366162045c6879eca9eab9b7e89'
        }
      },
      searchProductsAPIDetails : {
        searchProductsAPI : 'abs/qapub/xapi/pgmsearch/v1/search/products',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'ae53203f912448a7a13c70272d5c75fb'
        }
      },
      cartAPIDetails : {
        cartAPI : '/abs/qapub/erums/cartservice/api/v1/cart/',
        editCartAPI : '/abs/qapub/erums/orderservice/api/v2/orders/',
        subscriptionKey : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        subscriptionKeyV2 : {
          key : 'Ocp-Apim-Subscription-Key',
          value : '3e4673736413478c8153f99172d30318'
        },
        apimBasePath:'/abs/qapub',
        cartV2API : '/abs/qapub/erums/cartservice/api/v2/cart/',
        guestCartBasePath : '/erums/guestcartservice/api/v2/guest/'
      },
      catalogConfig : {
        "catalog.service.enable" : "true",
        "catalog.xapi.enable" : "true",
        "swy.api.apim.catalog.service.baseurl" : "qa.apim.azwestus.stratus.albertsons.com",
        "swy.api.catalog.service.endpoint" : "/abs/qapub/catalog/catalogservice",
        "swy.api.catalog.service.apim.key" : "b0f931272efc4766a535e6030b79574d",
        "apim.api.catalog.path" : "/abs/qapub/xapi",
        "apim.api.catalog.virtual.shelf.endpoint" : "/catalog-deals/virtual-shelf",
        "apim.api.catalog.departments.endpoint"  : "/catalog-deals/departments",
        "apim.api.catalog.deals.endpoint" : "/catalog-deals/deals",
        "apim.api.catalog.product.bpn.endpoint" : "/catalog/products-by-bpn",
        "apim.api.catalog.product.upc.endpoint" : "/catalog/products-by-upc",
        "apim.api.catalog.increment.price.list.endpoint" : "/catalog/incrementPriceList",
        "apim.api.catalog.cba.endpoint" : "/catalog-deals/channel-based-availability",
        "mockinator.brand.index.service.baseurl" : "dev1.apim.azwestus.stratus.albertsons.com",
        "mockinator.brand.index.service.api.key" : "cc18c4fbb7f540099142b1f9adb2558f",
        "mockinator.brand.index.endpoint"  : "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
        "apim.api.brand.index.service.baseurl" : "qa.apim.azwestus.stratus.albertsons.com",
        "apim.api.brand.index.service.path" : "/abs/qapub/xapi",
        "apim.api.brand.index.service.endpoint" : "/v1/aisles/brandindex",
        "apim.api.brand.index.service.key" : "a6bbc777a82f45a9b1413af0ce35604f",
        "api.catalog.timeout.product.by.bpn" : "1000",
        "api.catalog.timeout.brand.index" : "3000",
        "swy.api.product.service.apim.key" : "b0f931272efc4766a535e6030b79574d",
        "api.catalog.timeout.pdp.data" : "1500"
      },
      j4uAPIDetails : {
        'X-SWY_VERSION': '1.0',
        'X-IBM-Client-Id': "9b1d97cf-4ddc-4e81-95e5-035c204c4ef6",
        'X-IBM-Client-Secret': "G1oW7jM5jF5nV7lR8rC6dU4wG1qS8uC5iD7rB5eJ0tD4eO0cJ6",
        "X-SWY_BANNER": "safeway",
        "x-swy-correlation-id": "01e7b8fd-f501-4519-886c-daf340fa6967",
        "X-SWY_API_KEY": "emjou",
        "X-SWY-APPLICATION-TYPE": "web",
        "X-SWY_VERSION_Offers": "1.1",
        'clipPath' : '/abs/qapub/web/j4u/api/offers/clip',
        'unclipPath' : '/abs/qapub/web/j4u/api/offers/unclip',
        'galleryPath': '/abs/qapub/web/j4u/api/offers/gallery',
        'instantAllocation': '/abs/qapub/xapi/offers/instantAllocationGallery',
        'companionGalleryApi': '/abs/qapub/xapi/offers/companiongalleryoffer'
      },
      offerDetailAPIDetails : {
        'offerDetailPath' : '/abs/qapub/xapi/offers',
        'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
        'offersByUpcPath': '/abs/qapub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
      },
      nimbusConfig : {
        "coupon.image.base.url" : "https://images.albertsons-media.com/is/image/ABSStage/",
        arSubscriptionKey:"49c7b49a2bf94a5ca7e318c84ca9cbb2",
        snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
        arAuthorizeBasePath: "/abs/acceptancepub",
        arScriptBasePath: "/abs/acceptancepub",
        couponTypes: {
          "PD": "Personalized Deal",
          "MF": "Coupon",
          "SC": "Coupon",
          "CC": "Coupon",
          "GR": "Grocery Reward",
          "TR": "Monopoly Prize",
          "WS": "Weekly Ad"
        },
        couponActionTypes: {
          "CL": "Clip",
          "CLD": "Clipped",
          "AC": "ADD",
          "ADC": "ADDED",
          "CLC": "Clip Coupon",
          "CLCUDC": "Clip Offer",
          "SCC": "Activate",
          "CC": "Bonus Path Completed"
        }
      },
      datapowerConfig:{
        cncSubscriptionKey: "d8c6d7783b604f618dd446e7c39c7c08"
      },
      wiremockAPIDetails: {
        allowWiremockService: true,
        subscriptionKey: "8ca6295a55f54368844b5982edc1cc01",
        playbackBaseUrl: "/abs/qapub/mock-playback/mockinator/playback",
        recorderBaseUrl: "/abs/qapub/mock-recorder/mockinator"
      },
      snsConfig: {
        url: '/abs/qapub/osar/snsorderorch/api/sns',
        apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
      },
      productsApiDetails : {
        subscriptionKey : {
          value : '2df5532da15c4218b46d35ecd6c6a699'
        }
      },
      domsApiDetails : {
        url : '/abs/qapub/osco/manageorderservice/api/v1',
        subscriptionKey : {
          key : 'ocp-apim-subscription-key',
          value : 'e3805df8a69a41c3811c068c8a9263ca'
        }
      },
      baseImageUrl : "//images.albertsons-media.com/is/image/ABSStage"
    },
    userInfoPath : '/bin/safeway/unified/userinfo?rand=659323&banner=safeway',
    offerDisclaimerPath : '/content/experience-fragments/www/Disclaimers/Offer-Disclaimer/offer-disclaimer.content.html'
  }
